// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mSlot[data-v-4145b35c] {\n    text-align: center;\n    height: 100%;\n    padding-top: 20%;\n}\n.mSlot-border-light[data-v-4145b35c] {\n    background-color: rgba(0, 132, 255, 0.473);\n}\n.mSlot-border-dark[data-v-4145b35c] {\n    background-color: rgba(0, 132, 255, 0.473);\n}\n", ""]);
// Exports
module.exports = exports;
